<template>
  <div>
    <item
      :item="record.data.form"
      :questions="questions"
      :response-sets="responseSets"
      :has-multiple-pages="record.data.form.items.length > 2"
      :questions-to-fetch="questionsToFetch"
    />
  </div>
</template>

<script>
  import Item from '@/_legacy/views/Analytics/Checklist/Items/Item';

  export default {
    name: 'Checklist',
    components: {
      Item,
    },
    props: {
      record: {
        type: Object,
        default: () => ({}),
      },
      questionsToFetch: {
        type: Array,
        required: true,
      },
    },
    computed: {
      questions() {
        return this.record.questions ?? {};
      },
      responseSets() {
        return this.record.data.form.params.response_sets ?? [];
      },
    },
  };
</script>
